import React from "react";

function GisData() {
  return (
    <>
      <h2 style={{ padding: "20px" }}>Dashboard</h2>
    </>
  );
}

export default GisData;